export default __webpack_public_path__ + "static/media/google-icon.ffe5bb53.png";